export function isCash(position) {
  return !!position?.symbol?.match(/CASH01/i);
}
